import { Shield } from 'lucide-react';

export interface QualityLabel {
  name: string;
  color: string;
  icon: string;
  description: string;
}

export const QUALITY_LABELS: Record<string, QualityLabel> = {
  platinum: {
    name: 'Platinum',
    color: 'bg-gradient-to-r from-gray-200 to-gray-400',
    icon: '🏆',
    description: 'Best-in-class facility with enterprise-grade infrastructure'
  },
  gold: {
    name: 'Gold',
    color: 'bg-gradient-to-r from-yellow-200 to-yellow-400',
    icon: '⭐',
    description: 'Premium facility with advanced security and support'
  },
  silver: {
    name: 'Silver',
    color: 'bg-gradient-to-r from-gray-100 to-gray-300',
    icon: '🥈',
    description: 'High-quality facility with reliable infrastructure'
  },
  bronze: {
    name: 'Bronze',
    color: 'bg-gradient-to-r from-orange-200 to-orange-300',
    icon: '🥉',
    description: 'Standard facility meeting basic requirements'
  }
};

export interface MeasureXStatus {
  ready: boolean;
  version?: string;
  features?: string[];
}

export function getMeasureXLabel(status: MeasureXStatus | undefined) {
  if (!status) {
    return {
      text: 'MeasureX Not Available',
      color: 'bg-gray-100 text-gray-800',
      description: 'This facility does not currently support MeasureX software'
    };
  }

  if (status.ready) {
    return {
      text: 'MeasureX Ready',
      color: 'bg-green-100 text-green-800',
      description: `Compatible with MeasureX v${status.version} - ${status.features?.join(', ')}`
    };
  }

  return {
    text: 'MeasureX Not Available',
    color: 'bg-gray-100 text-gray-800',
    description: 'This facility does not currently support MeasureX software'
  };
}

export function calculateQualityScore(facility: any): string {
  const scores = {
    uptime: facility.uptime >= 99.99 ? 3 : facility.uptime >= 99.9 ? 2 : 1,
    security: facility.securityLevel === 'enterprise' ? 3 : facility.securityLevel === 'advanced' ? 2 : 1,
    powerCost: facility.powerCost <= 0.05 ? 3 : facility.powerCost <= 0.06 ? 2 : 1,
    features: facility.features.length >= 5 ? 3 : facility.features.length >= 3 ? 2 : 1
  };

  const totalScore = Object.values(scores).reduce((a, b) => a + b, 0);

  if (totalScore >= 11) return 'platinum';
  if (totalScore >= 9) return 'gold';
  if (totalScore >= 7) return 'silver';
  return 'bronze';
}